<template>
  <Popup v-model="show" position="bottom">
    <datetime-picker
        :value="currentData"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :title="title"
        @confirm="onConfirm"
    />
  </Popup>
</template>
<script>


import {defineComponent} from "vue";
import {DatetimePicker, Popup} from "vant";

export default defineComponent({
  components: {Popup, DatetimePicker},
  props: {
    minDate: {
      type: Date
    },
    maxDate: {
      type: Date
    }
  },
  data() {
    return {
      title: '选择时间',
      currentData: new Date(),
      show: false
    }
  },
  methods: {
    open(title) {
      title && (this.title = title)
      this.show = true
    },
    onConfirm(value) {
      this.currentData = value
      this.show = false
      this.$nextTick().then(() => {
        this.$emit("confirm", value)
      })
    },
  }
})
</script>

<style scoped lang="scss">

</style>